import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import TheLogin from "@/components/Common/TheLogin";
//import TheRegister from "@/components/Common/TheRegister";
import TheConfirm from "@/components/Common/TheConfirm";
// закрытые компоненты
import TheMain from "@/components/Admin/TheMain";
import TheProfile from "@/components/Admin/TheProfile";
import ThePayments from "@/components/Admin/ThePayments";
import TheSchedulePayments from "@/components/Admin/TheSchedulePayments";
import TheDialogue from "@/components/Admin/TheDialogue";
import TheAppeals from "@/components/Admin/TheAppeals";
import TheApplications from "@/components/Admin/TheApplications";
import TheApplicationPaymentEarly from "@/components/Admin/TheApplicationPaymentEarly";
import TheApplication from "@/components/Admin/TheApplication";

import TheNormDocuments from "@/components/Admin/TheNormDocuments";
import TheUploadDocuments from "@/components/Admin/TheUploadDocuments";
// история загрузки документов на андеррайтинг
import TheDocumentHistory from "@/components/Admin/TheDocumentHistory";
import TheHistory from "@/components/Admin/TheHistory";

// тип ЛК (1,2 - ИПОТЕКА, РАССРОЧКА, 3 - СВИДЕТЕЛЬСТВА)
// const type = store.getters['authModule/user'] ? store.getters['authModule/user'] : 1

const router =  createRouter ({
    history: createWebHistory(),
    routes:[

        {
            path: '/',
            component: TheLogin,
            meta: {
                title: 'Авторизация',
                layout: 'login',
                auth: false
            },
            name: 'login',
        },

        {
            path: '/confirm/:id',
            component: TheConfirm,
            meta: {
                title: 'Авторизация',
                layout: 'login',
                auth: false
            },
            name: 'confirm',
        },

        // закрытые маршруты
        {
            path: '/profile',
            component: TheProfile,
            meta: {
                title: "Профиль",
                layout: 'admin',
                auth: true
            },
            name: 'profile',
        },

        {
            path: '/contract',
            component: TheMain,
            meta: {
                title: "Главная",
                layout: 'admin',
                auth: true
            },
            name: 'contract',
        },

        {
            path: '/payments',
            component: ThePayments,
            meta: {
                title: "Мои платежи",
                layout: 'admin',
                auth: true
            },
            name: 'payments',
        },

        {
            path: '/payments/schedule',
            component: TheSchedulePayments,
            meta: {
                title: "График платежей",
                layout: 'admin',
                auth: true
            },
            name: 'payments-schedule',
        },

        {
            path: '/messages',
            component: TheDialogue,
            meta: {
                title: "Мои сообщения",
                layout: 'admin',
                auth: true
            },
            name: 'dialogue',
        },

        {
            path: '/appeals',
            component: TheAppeals,
            meta: {
                title: "Мои обращения",
                layout: 'admin',
                auth: true
            },
            name: 'appeals',
        },

        {
            path: '/norm-documents',
            component: TheNormDocuments,
            meta: {
                title: "Нормативные документы",
                layout: 'admin',
                auth: true
            },
            name: 'documents',
        },

        {
            path: '/documents/upload',
            component: TheUploadDocuments,
            meta: {
                title: "Мои документы",
                layout: 'admin',
                auth: true
            },
            name: 'documents-upload',
        },

        {
            path: '/document/:id/history',
            component: TheDocumentHistory,
            meta: {
                title: "Загрузить документ",
                layout: 'admin',
                auth: true
            },
            name: 'document-upload',
        },

        {
            path: '/applications',
            component: TheApplications,
            meta: {
                title: "Услуги и сервисы",
                layout: 'admin',
                auth: true
            },
            name: 'applications',
        },

        {
            path: '/application/payment',
            component: TheApplicationPaymentEarly,
            meta: {
                title: "Заявление на досрочное погашение",
                layout: 'admin',
                auth: true
            },
            name: 'application-payment',
        },

        {
            path: '/application/fns',
            component: TheApplication,
            meta: {
                title: "Справка в ФНС России",
                layout: 'admin',
                auth: true
            },
            name: 'application-fns',
        },

        {
            path: '/application/pfr',
            component: TheApplication,
            meta: {
                title: "Справка в Пенсионный Фонд России",
                layout: 'admin',
                auth: true
            },
            name: 'application-pfr',
        },

        {
            path: '/application/credit',
            component: TheApplication,
            meta: {
                title: "Справка о кредитной истории",
                layout: 'admin',
                auth: true
            },
            name: 'application-credit',
        },

        {
            path: '/application/balance',
            component: TheApplication,
            meta: {
                title: "Справка об остатке ссудной задолженности",
                layout: 'admin',
                auth: true
            },
            name: 'application-balance',
        },

        {
            path: '/history',
            component: TheHistory,
            meta: {
                title: "История действий",
                layout: 'admin',
                auth: true
            },
            name: 'history',
        },

        {
            path: '/:notFound(.*)', redirect: '/'
        },
    ],

    // переопределить классы активных ссылок
    linkActiveClass: 'active',
    linkExactActiveClass: 'active'
})


router.beforeEach((to, from, next) =>{
    document.title = to.meta.title

    // закрытый или открытый маршрут
    const requireAuth = to.meta.auth
    const nextStart = '/'
    const nextDefault = '/contract'
    let toDefaultRoute = false

    // длительность сеанса авторизации 3 часа
    //const maxDuration = 10800

    const maxDuration = 1800

    // время авторизации закончилось
    let isAuthorizationCompleted = false

    // если пользователь существует
    if (store.getters['authModule/user']) {

        let authDuration = Math.round(Date.now()/1000) - store.getters['authModule/user']['startAuthorization']
        // максимальное время работы 2 часа
        // console.log(maxDuration - authDuration)
        // закончить сеанс авторизации
        if (maxDuration <= authDuration){
            isAuthorizationCompleted = true
        }

        // console.log(maxDuration - authDuration)

        // если пользователь авторизован, на страницу входа не попасть, редирект на /contract (1 раздел)
        if (to.path === '/' && store.getters['authModule/isAuth']) {
            toDefaultRoute = true
        }

        // статус участника, все маршруты редирект на /contract
        if (Number(store.getters['authModule/user'].type) === 0) {
            if (to.path !== '/contract' && to.path !== '/contract/' && to.path !== '/profile' && to.path !== '/profile/') {
                toDefaultRoute = true
            }
        }

        // свидетельства (статус 3)
        if (Number(store.getters['authModule/user'].type) === 3) {
            if (
                (to.path === '/payments' || to.path === '/payments/')
                ||
                (to.path === '/services' || to.path === '/services/')
                ||
                (to.path === '/history' || to.path === '/history/')
            ) {
                toDefaultRoute = true
            }
        }

        // рассрочка и ипотека (статус < 3)
        // все разделы с документами закрыты
        if (Number(store.getters['authModule/user'].type) == 1 || Number(store.getters['authModule/user'].type) == 2) {
            if (to.path.indexOf('/doc') === 0) {
                toDefaultRoute = true
            }
        }

    }

    // открытый маршрут или закрытый + пользователь авторизован
    if (!requireAuth || (requireAuth && store.getters['authModule/isAuth'])){

        if (isAuthorizationCompleted){
            // время действия авторизации закончилось
            store.commit('authModule/logout')
            next(nextStart)

        } else {
            // время действия авторизации не закончилось
            if (!toDefaultRoute) {
                // переход по ссылке
                next()
            } else {
                // переход на '/contract'
                // выполняется для всех закрытых маршрутов текущего статуса
                next(nextDefault)
            }
        }

    } else if (requireAuth && !store.getters['authModule/isAuth']){
        // требуется авторизация, но пользователь не авторизован
        // редирект на '/'
        next(nextStart)
    }

});

export default router;